import React, { ReactNode } from "react";

interface IButtonInfoProps {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}

function ButtonInfo({
  children,
  className = "text-left mb-2",
  onClick = () => {},
}: IButtonInfoProps) {
  return (
    <button
      className={`btn-info ${className}`}
      onClick={(e) => {
        e.stopPropagation();
        onClick();
      }}
    >
      {children}
    </button>
  );
}

export default ButtonInfo;
